import { render, staticRenderFns } from "./Unpublished.vue?vue&type=template&id=5c6f0ad6&scoped=true"
import script from "./Unpublished.vue?vue&type=script&lang=js"
export * from "./Unpublished.vue?vue&type=script&lang=js"
import style0 from "./Unpublished.vue?vue&type=style&index=0&id=5c6f0ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f0ad6",
  null
  
)

export default component.exports